import {
  IFacialRecognitionProcess,
  TCodeVerificationProccessType,
  TItemType,
  TOnboardingType,
} from 'shared/domain/entities';

export const sharedQueries = {
  base: ['shared'] as const,

  acceptanceTerms: (budgetId: number | undefined) => [
    ...sharedQueries.base,
    'acceptanceTerms',
    budgetId,
  ],

  customerBenefit: (id: number | undefined) =>
    [...sharedQueries.base, 'customerBenefit', id] as const,

  addressData: (postalCode: string | undefined) => [
    ...sharedQueries.base,
    'addressData',
    postalCode,
  ],

  verifyNpsSessionFeedback: (
    id?: number | null,
    loggedAsGuest?: boolean | null,
  ) =>
    [
      ...sharedQueries.base,
      'verifyNpsSessionFeedback',
      id,
      loggedAsGuest,
    ] as const,

  verificationCodeAvailability: (
    entityId: number | undefined,
    proccess: TCodeVerificationProccessType | undefined,
  ) =>
    [
      ...sharedQueries.base,
      'verificationCodeAvailability',
      entityId,
      proccess,
    ] as const,

  items: (type: TItemType) => [...sharedQueries.base, 'items', type] as const,

  facialRecognition: (
    process: IFacialRecognitionProcess,
    type: TOnboardingType | null,
  ) =>
    [...sharedQueries.base, 'facialRecognition', ...process.key, type] as const,
};
